import PropTypes from 'prop-types';
import FigureThumbnail from './figureThumbnail';

export default function FigureGrid({ figures }) {
  return (
    <ul className="figure-grid">
      {figures.map(figure => <FigureThumbnail figure={figure} key={figure.id} />)}
    </ul>
  );
}

FigureGrid.propTypes = {
  figures: PropTypes.arrayOf(PropTypes.shape({
    figure: PropTypes.shape({ small: PropTypes.string }),
    id: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
};
